import { makeStyles } from "@material-ui/core/styles";
import { Button, ListItem, ListItemAvatar } from "@mui/material";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import LoadingGrid from "components/Loading/LoadingFull";
import MeuPlanoAtual from "components/Uteis/MeuPlanoAtual";
import MySnackbarErro from "components/Uteis/MySnackbarErro";
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import api from "services/api.js";
import { serverApi } from "services/constante.js";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: 'trnsparent',
    },
    titulo: {
        fontSize: '14px',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500
    },
    inline: {
        display: 'inline',
        color: '#787878',
        fontFamily: 'Montserrat, sans-serif',
    },
    iconColor: {
        color: "#FFF"
    },
    boxPontosDK: {
        position: 'absolute',
        bottom: '15px',
        left: '2px',
        color: '#737495'
    },
    boxPontosMB: {
        position: 'absolute',
        bottom: '0px',
        left: '5px',
        top: '30px',
        color: '#737495'
    },
    itemList: {
        position: 'relative',
        backgroundColor: 'white',
        marginBottom: '15px',
        borderRadius: '10px',
        marginRight: '20px',
        marginLeft: '20px',
        paddingTop: '15px',
        cursor: 'pointer',
    },
    statusDisplay: {
        width: 10,
        height: 10,
        display: 'inline-block',
        borderRadius: '5px',
        marginRight: '5px'
    },
    boxStatus: {
        marginRight: '7px',
        fontFamily: 'Montserrat, sans-serif',
    },
    textStatusDisplay: {
        color: '#787878'
    },
    boxConteudo: {
        paddingLeft: '5px'
    },
    headerDivider: {
        borderLeft: '1px solid #e2e2e2',
        borderRight: '1px solid #e2e2e2',
        height: '77px',
        position: 'absolute',
        left: '65px',
        top: '35px'
    }
}));


export default function PedidoContrato(props) {
    const [loadingGrid, setLoadingGrid] = useState(true);
    const [contratoLink, setContratoLink] = useState(null);
    const [isErro, setIsErro] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const classes = useStyles();

    const vendaId = props?.match?.params?.vendaId;
    // console.log('pr', props);

    const carregarDados = async () => {
        try {
            setIsErro(false);
            setLoadingGrid(true);

            const userResponse = await api.get(serverApi.url + serverApi.versao + '/Usuario/Perfil');
            const user = userResponse.data;
            const userGuid = user.Guid;

            const formData = new FormData();
            formData.append("function", "get_contrato");
            formData.append("venda_id", vendaId);
            const res = await api.post(serverApi.urlPHP + '/venda.php', formData);
            setContratoLink(res.data.contrato_link);
        } catch (e) {
            console.error(e);
            setErrorMessage("Não foi possível consultar seu contrato no momento.");
            setIsErro(true);
        } finally {
            setLoadingGrid(false);
        }
    };

    const aceitarContrato = async () => {
        try {
            setIsErro(false);
            setLoadingGrid(true);

            const formData = new FormData();
            formData.append("function", "assinar_contrato");
            formData.append("venda_id", vendaId);
            const res = await api.post(serverApi.urlPHP + '/venda.php', formData);

            props.history.push(`/app/venda/forma-pagamento/${vendaId}`);
        } catch (e) {
            console.error(e);
        } finally {
            setLoadingGrid(false);
        }
    };

    const formatarValor = (value) => {
        const numericValue = Number.parseFloat(value);
        return numericValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
    }

    useEffect(() => {
        carregarDados();
    }, []);

    return (
        <div>
            <LoadingGrid display={loadingGrid} />
            <div style={{ display: (!loadingGrid && !isErro ? '' : 'none') }}>
                <div style={{ display: "flex", flex: 1, flexDirection: "column", alignItems: "center", gap: "10px" }}>
                    <h3>Aceite os termos abaixo para continuar:</h3>
                    <div style={{ width: 600, height: 400, overflow: "scroll", border: "1px solid black" }}>
                        <Document
                            file={contratoLink}
                        >
                            <Page pageNumber={1} />
                            <Page pageNumber={2} />
                            <Page pageNumber={3} />
                        </Document>
                    </div>

                    <div style={{ display: "flex" }}>
                        <Button variant="contained" onClick={aceitarContrato}>
                            Declaro que li e aceito os termos
                        </Button>
                    </div>
                </div>
            </div>
            <MySnackbarErro IsErro={isErro} Mensagem={errorMessage} />
        </div>
    );
}